export default function get(obj, path, sep='.') {
  const pathArr = path.split(sep);
  let o = obj;
  for (let v of pathArr) {
    if (!o[v]) return undefined;
    o = o[v];
  }
  return o;
}
